import { styled } from 'styled-components';
import { motion } from 'framer-motion';
import { theme } from '../styles';

const Title = ({ as, children }) => (
  <TitleWrapper
    as={as}
    initial={theme.fadeIn.initial}
    animate={theme.fadeIn.animate}
    transition={theme.fadeIn.transition(theme.delaySm)}
  >
    {children}
  </TitleWrapper>
);

const TitleWrapper = motion(styled.h1`
  margin: 0 auto;
  text-align: center;
`);

export default Title;
